export default "__VITE_ASSET__ks6t5uUf__"